
export const BreadcrumbSiteBaseUrl = (profile: {
  BASE_URL?: string;
} | undefined) => {
  if(!profile){
    return null;
  }
  // if BASE_URL is missing a following slash, add one for consistency.
  const fixedSiteBaseUrl = profile?.BASE_URL?.charAt(profile?.BASE_URL?.length -1) != '/' ? `${profile?.BASE_URL}/` : profile?.BASE_URL;
  // if BASE_URL is missing http/s then add the current location protocol for consistency.
  const siteBasePath = fixedSiteBaseUrl?.includes('http') ? fixedSiteBaseUrl : window?.location?.protocol + '//' + fixedSiteBaseUrl;

  return siteBasePath
}